import classes from './SkillGrid.module.scss';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const SkillGrid = ({ skills }) => {
	return (
		<div className={`${classes["skill-grid"]}`}>
			{skills.map((skill, i)=> (
				<Tippy content={skill.title} animation="fade" placement="top-start">
					<div className={`${classes["skill-grid__image"]}`} key={i}>
						<img src={skill.image} alt={skill.title} title={skill.title} />
					</div>
				</Tippy>
			))}
		</div>
	)
}
  
export default SkillGrid;